import { SURVEY_RESPONSES_ENDPOINT } from "../config";
import { createInstance } from "./createInstance";
const instance = createInstance(SURVEY_RESPONSES_ENDPOINT);
export default instance;
